import { OneOrMany, isMany } from '../types/one-or-many';

export const toMany = <T>(value: OneOrMany<T>): T[] => (isMany(value) ? value : [value]);
